import React from "react";

export const CalendarIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8008 12.7998H11.4008C11.5599 12.7998 11.7125 12.863 11.825 12.9756C11.9376 13.088 12.0008 13.2407 12.0008 13.3998V17.5998"
        fill="currentColor"
      />
      <path
        d="M10.8008 12.7998H11.4008C11.5599 12.7998 11.7125 12.863 11.825 12.9756C11.9376 13.088 12.0008 13.2407 12.0008 13.3998V17.5998"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8008 17.5996H13.2008"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.2 5.40039H19.8C19.8 5.40039 21 5.40039 21 6.60038V19.8003C21 19.8003 21 21.0003 19.8 21.0003H4.2C4.2 21.0003 3 21.0003 3 19.8003V6.60038C3 6.60038 3 5.40039 4.2 5.40039Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 10.2002H21"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.80078 7.19997V3"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.1992 7.19997V3"
        stroke="#6C6E70"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
